// extracted by mini-css-extract-plugin
export default {"eholdings-back-end-error":"eholdings-back-end-error---v2mdM","ebsco-connect-link":"ebsco-connect-link---V4fHA","ebsco-connect-link-icon":"ebsco-connect-link-icon---woFFZ"};